const PERMISSION_REQUEST_KEY = 'ka:browser-notification-permission-requested';
const DEDUPE_PREFIX = 'ka:browser-notification-dedupe:';
const DEDUPE_WINDOW_MS = 4000;

function canUseNotificationApi() {
  return typeof window !== 'undefined' && 'Notification' in window;
}

function safeNow() {
  return Date.now();
}

function readLocalTimestamp(key) {
  try {
    const raw = window.localStorage.getItem(key);
    const value = Number(raw);
    return Number.isFinite(value) ? value : 0;
  } catch {
    return 0;
  }
}

function writeLocalTimestamp(key, timestamp) {
  try {
    window.localStorage.setItem(key, String(timestamp));
  } catch {
    // Ignore storage failures.
  }
}

function shouldSkipDuplicate(dedupeKey) {
  if (!dedupeKey || typeof window === 'undefined' || !window.localStorage) return false;

  const key = `${DEDUPE_PREFIX}${dedupeKey}`;
  const now = safeNow();
  const previous = readLocalTimestamp(key);

  if (now - previous < DEDUPE_WINDOW_MS) {
    return true;
  }

  writeLocalTimestamp(key, now);
  return false;
}

export async function prepareBrowserNotifications() {
  if (!canUseNotificationApi()) return;

  if (Notification.permission !== 'default') return;

  try {
    if (window.localStorage.getItem(PERMISSION_REQUEST_KEY)) return;
    window.localStorage.setItem(PERMISSION_REQUEST_KEY, String(safeNow()));
    await Notification.requestPermission();
  } catch {
    // Ignore permission failures.
  }
}

export function showTeamworkBrowserNotification(payload = {}) {
  if (!canUseNotificationApi()) return;
  if (Notification.permission !== 'granted') return;
  if (typeof document !== 'undefined' && document.visibilityState === 'visible') return;

  const teamworkId = payload?.teamworkId ? String(payload.teamworkId) : '';
  const messageId = payload?.messageId ? String(payload.messageId) : '';
  const title = payload?.teamworkCode
    ? `${payload.teamworkCode} - New Teamwork Message`
    : 'New Teamwork Message';
  const body = payload?.body || payload?.messagePreview || 'You received a new teamwork message.';
  const link = teamworkId
    ? `/admin/teamwork?teamworkId=${encodeURIComponent(teamworkId)}`
    : '/admin/teamwork';

  const dedupeKey = messageId || `${teamworkId}:${body}`;
  if (shouldSkipDuplicate(dedupeKey)) return;

  const notification = new Notification(title, {
    body,
    tag: messageId ? `teamwork-msg-${messageId}` : `teamwork-${teamworkId || 'general'}`,
    renotify: false,
    data: { link },
  });

  notification.onclick = () => {
    try {
      window.focus();
      window.location.href = link;
    } catch {
      // Ignore focus or navigation failures.
    }
    notification.close();
  };
}
